import { render, staticRenderFns } from "./StandardEntry.vue?vue&type=template&id=01c4545e&scoped=true&"
import script from "./StandardEntry.vue?vue&type=script&lang=js&"
export * from "./StandardEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4545e",
  null
  
)

export default component.exports